// Import package from Soil plugin example.
import $ from "@modules/jquery";

$(function() {
    //
});

function equalizeHeight(container) {
  let currentTallest = 0;
  let currentRowStart = 0;
  const rowDivs = new Array();
  let topPosition = 0;
  $(container).each(function () {
    const $el = $(this);
    $($el).height("auto");
    topPosition = $el.position().top;

    if (currentRowStart !== topPosition) {
      for (let currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPosition;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest =
        currentTallest < $el.height() ? $el.height() : currentTallest;
    }
    for (let currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}
$(document).ready(function () {


  const eventsBlock = $(".ms_cards.event-slider .cards");
  const screenSize = $(window).width();

  if (screenSize > 600) {
    if (eventsBlock.length) {
        eventsBlock.each(function () {
        const card = $(this).find(".card-section");
        const excerpt = $(this).find(".excerpt");
        equalizeHeight(card);
        equalizeHeight(excerpt);
      });
    }

  }
});
window.addEventListener("resize", function () {
    equalizeHeight();
});
$(window).on("load", function () {
    equalizeHeight();
});


